import { API, setAuthToken } from '../../../config/API.js';
import { GET_MITRA, SET_LOADING_MITRA, SET_PAGINATION_MITRA } from '../constant.js';

export const getMitra = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_MITRA,
      payload: true,
    });
    API.get(`admin/mitra?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_MITRA,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_MITRA,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_MITRA,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_MITRA,
          payload: 0,
        });
      });
  };
};

export const addMitra = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/mitra/add", params);
};

export const getDetailMitra = (id) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get("admin/mitra/" + id);
};

export const updMitra = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/mitra/edit", params);
};

export const delMitra = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/mitra/delete/" + code);
};
